<template>
  <div class="py-10 py-md-0">
    <h1 class="login-title mb-5 px-10 px-md-0">VOCÊ CONCLUIU O TESTE!</h1>

    <v-card class="my-8 px-5 py-15 pa-md-10 card-info" light flat>
      <p>
        Na próxima tela você irá ver duas sugestões de caminho que combinam com o seu perfil. Essas duas alternativas estão exemplificadas aqui pelas <b>Escolas da Unisinos</b>. Cada Escola é composta
        por um distinto conjunto de Cursos, Programas, Projetos e Atividades de pesquisa, Dè uma olhada nas opções e veja se alguma combina com você!
      </p>

      <p>
        <b>Mas lembre-se</b>: essas são orientações gerais, baseadas nas suas respostas anteriores. Você pode voltar a qualquer momento para refazer o teste. Consulte o material sempre que sentir
        necessidade, ok?
      </p>
    </v-card>
    <div class="text-center">
      <v-btn color="#003da4" to="/questoes" dark depressed :small="app">Voltar</v-btn>
      <v-btn color="#003da4" @click="finish()" dark depressed :small="app">Clique para ver o seu resultado</v-btn>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApi } from '@/global'
import { mapState } from 'vuex'

export default {
  name: 'Home',
  computed: {
    app() {
      return this.$vuetify.breakpoint.smAndDown
    },
    ...mapState(['user', 'answers']),
  },
  methods: {
    finish() {
      const url = `${baseApi}/tv_result`
      const qs = require('qs')
      this.loading = true
      axios.post(url, qs.stringify(this.answers)).then((res) => {
        this.$store.dispatch('setResultInfo', res.data.results)
        this.loading = false
        this.$router.push('/result')
      })
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    if (!this.user) {
      this.$router.push('/')
    }
  },
}
</script>

<style>
.z-top {
  z-index: 100 !important;
}
</style>
